export enum BalanceEntryType {
    INCOME = 'income',
    EXPENSE = 'expense'
}

export enum RecurrenceType {
    WEEKLY = 'weekly',
    MONTHLY = 'monthly'
}

export interface BaseTransactionData {
    id: number;
    description: string;
    descriptionId: number;
    amount: number;
    note: string | null;
    type: BalanceEntryType;
}

export interface TransactionData extends BaseTransactionData {
    date: string;
    recurrentParentId: number | null;
    mileageAllowance: number | null;
    type: BalanceEntryType;
    attachment: {
        type: string | null,
        url: string,
        name: string
    } | null;
}

export interface RecurringTransactionData extends BaseTransactionData {
    remainingOccurrences: number | null; // null if indefinite
    nextOccurrenceDate: string | null;
    lastOccurrenceDate: string | null; // set if nextOccurrenceDate is null
    recurrenceType: RecurrenceType;
    isActive: boolean;
}

export function isMileageTransaction(transactionData: TransactionData | null): boolean {
    return (transactionData?.descriptionId === 199 || transactionData?.description === 'Mileage Allowance (Car)')
        || (transactionData?.descriptionId === 799 || transactionData?.description === 'Mileage Allowance (Motorbike)');
}